export enum ActionType {
  LOGIN = 'login',
  REQUEST = 'request',
  LOGIN_AND_REQUEST = 'loginAndRequest',
  NONE = 'none',
}
